import React from 'react'
import { AppBar, Toolbar, Hidden, Link, useScrollTrigger, Slide, Typography } from '@material-ui/core'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import SixpenceLogo from 'img/logo.svg'
import MainNavigationList from 'components/Navigation/MainNavigationList'
import Mobile from 'components/Navigation/Mobile'

const useStyles = makeStyles(({ palette: { getContrastText, primary: { dark } } }) => {
  return {
    root: {
      backgroundColor: dark
    },
    logoLink: {
      lineHeight: 0,
      flexGrow: 1
    },
    logoImage: {
      width: '6rem'
    },
    settingsLink: {
      color: getContrastText(dark),
      flexGrow: 1
    }
  }
})

function HideOnScroll({ children }) {
  const trigger = useScrollTrigger()
  return (
    <Slide appear={false} direction='down' in={!trigger}>{children}</Slide>
  )
}

export default function MainBar() {
  const classes = useStyles()
  const { pathname: currentPath } = useLocation()
  const inSettings = currentPath.substring(0, currentPath.lastIndexOf('/')) === '/settings'

  return (
    <HideOnScroll>
      <AppBar elevation={0} position='sticky' className={classes.root}>
        <Toolbar>
          <Hidden smUp>
            <Mobile />
          </Hidden>
          {inSettings ? (
            <Link
              component={RouterLink}
              to='/settings'
              className={classes.settingsLink}
            >
              <Typography variant='h6'>Settings</Typography>
            </Link>
          ) : (
            <Link
              component={RouterLink}
              to='/home'
              className={classes.logoLink}
            >
              <img className={classes.logoImage} alt='sixpence logo' src={SixpenceLogo} />
            </Link>
          )}

          <Hidden xsDown>
            <MainNavigationList />
          </Hidden>
        </Toolbar>
      </AppBar>
    </HideOnScroll>
  )  
}

